import { ECourierStatus } from '@northladder/services';

import {
  CircleQuestionMark,
  GradeChangeIcon,
  PackageDeliveredIcon,
  PackageReturnedIcon,
  PackageUndeliveredIcon,
  TIconType,
  TruckInTransitIcon,
  TruckUndeliveredIcon,
} from '../../icons';

interface ICourierStatusBadgeOptions {
  className: string;
  Icon: TIconType;
}

/**
 * -----------------------------------------------------------------------------
 * This returns the configuration for the deal courier status badge to customize
 * the appearance of the badge with the given courier status.
 */
export function getDealCourierStatusBadgeOptions(
  courierStatus: ECourierStatus
): ICourierStatusBadgeOptions {
  switch (courierStatus) {
    case ECourierStatus.DELIVERY_REFUSED:
      return {
        className:
          'bg-input-background-focused border-rank-normal-border text-rank-hot-text',
        Icon: TruckUndeliveredIcon,
      };
    case ECourierStatus.RETURNED:
      return {
        className:
          'bg-input-background-focused border-rank-normal-border text-rank-hot-text',
        Icon: PackageReturnedIcon,
      };
    case ECourierStatus.DELIVERED:
      return {
        className:
          'bg-rank-winning-bg border-rank-winning-border text-rank-winning-text',
        Icon: PackageDeliveredIcon,
      };
    case ECourierStatus.IN_TRANSIT:
      return {
        className:
          'bg-input-background-focused border-rank-border text-action-label',
        Icon: TruckInTransitIcon,
      };
    case ECourierStatus.CANCELLED:
      return {
        className: 'bg-rank-hot-bg border-rank-hot-border text-rank-hot-text',
        Icon: PackageUndeliveredIcon,
      };
    case ECourierStatus.GRADE_REVIEW:
      return {
        className:
          'bg-rank-hot-bg border-card-error-border text-action-icon-error',
        Icon: GradeChangeIcon,
      };
    default:
      return {
        className: 'bg-rank-hot-bg border-rank-hot-border text-rank-hot-text',
        Icon: CircleQuestionMark,
      };
  }
}
